import { addValidationRule } from 'formsy-react'

const cleanInput = value => value.replace(/[^\d]+/g, '')

const calculateCNPJCheckDigit = (numbers, weights) => {
    let sum = 0
    for (let i = 0; i < weights.length; i++) {
        sum += parseInt(numbers[i]) * weights[i]
    }
    const remainder = sum % 11
    return remainder < 2 ? 0 : 11 - remainder
}

const calculateCPFCheckDigit = numbers => {
    const length = numbers.length
    let sum = 0

    for (let i = 0; i < length; i++) {
        sum += parseInt(numbers[i]) * (length + 1 - i)
    }

    const result = (sum * 10) % 11
    return [10, 11].includes(result) ? 0 : result
}

export const loadValidations = () => {
    addValidationRule('isValidCNPJ', isValidCNPJ)
    addValidationRule('isValidCPF', isValidCPF)
    addValidationRule('isValidCNPJLength', isValidCNPJLength)
    addValidationRule('isValidCPFLength', isValidCPFLength)
}
export const isValidCNPJ = (values, cnpj) => {
    if (!cnpj) return false
    cnpj = cleanInput(cnpj)

    if (/^(\d)\1{13}$/.test(cnpj)) return false

    const base = cnpj.substring(0, 12)
    const firstWeights = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
    const secondWeights = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

    const digit1 = calculateCNPJCheckDigit(base, firstWeights)
    const digit2 = calculateCNPJCheckDigit(base + digit1, secondWeights)

    return cnpj === base + digit1 + digit2
}

export const isValidCNPJLength = (values, cnpj) => {
    if (!cnpj) return false
    cnpj = cleanInput(cnpj)

    return cnpj.length === 14
}

export const isValidCPF = (values, cpf) => {
    if (!cpf) return false

    cpf = cleanInput(cpf)

    if (/^(\d)\1{10}$/.test(cpf)) return false

    const base = cpf.substring(0, 9)
    const digit1 = calculateCPFCheckDigit(base)
    const digit2 = calculateCPFCheckDigit(base + digit1)

    return cpf === base + digit1 + digit2
}

export const isValidCPFLength = (values, cpf) => {
    if (!cpf) return false
    cpf = cleanInput(cpf)
    return cpf.length === 11
}
